module.exports = __webpack_public_path__ + "img/clock.8138d397.svg";